import React from "react";
import './Footer.css';
const Footer = () => {
  return (
    <footer class="bg-dark text-center text-white">
      <div class="container p-4 pb-0">
        <section class="mb-4" > 
          <a
            class="btn btn-primary btn-floating m-1"
            // style={"background-color:#3b5998;"}
            style={{ backgroundColor: "#3b5998" }}
            href="https://facebook.com/rakib.rscse"
            role="button"
            target="_blank"
          >
            <i class="fab fa-facebook-f"></i>
          </a>

          <a
            class="btn btn-primary btn-floating m-1"
            style={{ backgroundColor: "#55acee" }}
            href="#!"
            role="button"
          >
            <i class="fab fa-twitter"></i>
          </a>

          <a
            class="btn btn-primary btn-floating m-1"
            style={{ backgroundColor: "#dd4b39" }}
            href="#!"
            role="button"
          >
            <i class="fab fa-google"></i>
          </a>

          <a
            class="btn btn-primary btn-floating m-1"
            style={{ backgroundColor: "#ac2bac" }}
            href="#!"
            role="button"
          >
            <i class="fab fa-instagram"></i>
          </a>

          <a
            class="btn btn-primary btn-floating m-1"
            style={{ backgroundColor: "#0082ca" }}
            href="https://www.linkedin.com/in/rakib-rscse/"
            role="button"
            target="_blank"
          >
            <i class="fab fa-linkedin-in"></i>
          </a>

          <a
            class="btn btn-primary btn-floating m-1"
            style={{ backgroundColor: "#333333" }}
            href="https://github.com/Rakib-RS"
            role="button"
            target="_blank"
          >
            <i class="fab fa-github"></i>
          </a>
        </section>
      </div>

      <div
        class="text-center p-3"
        style={{ backgroundColor: "#330000" }}
        // style="background-color: rgba(0, 0, 0, 0.2);"
      >
        © 2021
        <a class="text-white"> Rakib</a>
      </div>
    </footer>
  );
};

export default Footer;
